import type { CSSProperties, ReactNode } from 'react';
import s from './shell.module.css';

/** Khung trang theo board Mint (biến CW): `list` khối giữa 1184 / 1240 / 1264 · `detail` 1184 / 1240 / 1590 (Mint-JobDetail) ·
 *  `table` = MỌI màn bảng dữ liệu + MỌI báo cáo / tổng quan (QĐ 29/Oct 17:05) 1184 / 1240 / 1590
 *  (QĐ anh David 29/Oct 17:02 — board ghi 1264; danh sách board ở docs/ref/LOGI-Mint-cho-chot.md) · `form` khối con canh giữa 880 ·
 *  `tool` màn công cụ (Box, Hei, Files): giãn hết bề ngang, không khối CW, lề 0, cao 100%.
 *  Bề ngang do shell `.content` quyết, KHÔNG giãn theo màn. `pad` ghi đè lề tối thiểu (px).
 *  `dock` = bảng phải 372 (Mint-Cost / Quote / TMS 1920: dock.w = 372): ≥ 1800 dính mép phải, cao hết màn, khối nội dung giữ 1264
 *  canh giữa phần còn lại; < 1800 xếp dưới nội dung như một thẻ.
 *  `cw` = bề ngang khối nội dung hẹp hơn mặc định (board 1280 ghi 1168 / 1158 / 1142 thay vì 1184): canh giữa, không nới rộng quá khối shell. */
export function Page({ kind = 'list', pad, cw, dock, children }: { kind?: 'list' | 'table' | 'detail' | 'form' | 'tool'; pad?: number; cw?: number; dock?: ReactNode; children: ReactNode }) {
  const cls = `${s.page} ${kind === 'detail' ? s.pageDetail : kind === 'table' ? s.pageTable : kind === 'form' ? s.pageForm : kind === 'tool' ? s.pageTool : ''}`;
  return (
    <div className={cls} style={pad === undefined && cw === undefined ? undefined : ({ ...(pad === undefined ? null : { '--pg-x': `${pad}px` }), ...(cw === undefined ? null : { maxWidth: cw, marginInline: 'auto', width: '100%' }) } as CSSProperties)}>
      {children}
      {dock && <aside className={s.dockSlot}>{dock}</aside>}
    </div>
  );
}
